var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:_vm.sectionClass},[_c('Head',{attrs:{"title":"Hubungi Kami"}}),_vm._v(" "),_c('h1',[_vm._v("Kontak Kami")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }